import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { CHURCH } from "../../lib/data";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (!loading && user) navigate("/admin", { replace: true }); }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0A0A0A] text-white">
      <div className="hidden lg:flex flex-col justify-between p-14 relative grain">
        <img src={CHURCH.logo} alt="One Love Ministries" className="w-40" />
        <div>
          <h1 className="font-display font-extrabold tracking-tight text-5xl leading-[1.02] mb-4">Church<br /><span className="text-[#E63946]">Dashboard</span></h1>
          <p className="text-white/50 max-w-sm">Manage service times, events, sermons, leadership, and ministries — all in one place.</p>
        </div>
        <p className="text-white/30 text-sm">One Church. One Family. One Love.</p>
      </div>
      <div className="grid place-items-center p-8">
        <div className="w-full max-w-sm text-center">
          <img src={CHURCH.logo} alt="One Love Ministries" className="w-28 mx-auto mb-8 lg:hidden" />
          <h2 className="font-display font-bold text-3xl mb-3">Admin Sign In</h2>
          <p className="text-white/50 mb-10">Sign in with the church's authorized Google account to manage your website.</p>
          <button onClick={login} data-testid="google-login-btn"
            className="w-full inline-flex items-center justify-center gap-3 rounded-full bg-white text-[#0A0A0A] py-4 font-medium hover:bg-white/90 transition-colors">
            <LogIn size={18} /> Continue with Google
          </button>
          <p className="text-white/30 text-xs mt-6">Only authorized administrators can access this area.</p>
        </div>
      </div>
    </div>
  );
}
